/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  app.DistrictPopupView = app.View.extend({
    events: {
      'click .district-input': 'togglePopup',
      'click .scrollable li': 'selectDistrict',
      'click .district-field .arrow_down': 'togglePopup',
    },
    additionalOptions: ['jpDistricts', 'jpDistrictsIds', 'jpModel', 'districts', 'withHiddenDistrictField', 'filledFields'],
    /**
     * @inheritDoc
     */
    run: function () {
      if (!this.districts) {
        this.districts = new app.Districts();
      }
      this.districtFields = this.$('.district-field');
      this.districtInput = this.$('.district-input');
      this.districtInputId = this.$('.district-input-id');
      this.districtSelect = this.$('.district-select');
      this.districtTemplate = app.helpers.TemplateHelper.getTemplate('#district-template');
      this.isOpenPopup = false;
      this.listenTo(Backbone, 'bodyView:click', this.bodyClick);
      this.listenTo(this.jpDistricts, 'add', this.render);
      this.listenTo(this.jpModel, 'remove', this.removeDistrict);
      this.listenTo(this.jpDistricts, 'remove', this.render);
    },
    /**
     * Определяет, есть ли у города список районов.
     * @param {number} settlementId ID населенного пункта.
     * @param {number} districtId ID района.
     * @param {Object} districts Коллекция районов города
     */
    checkDistrict: function (settlementId, districtId, districts) {
      if (this.withHiddenDistrictField) {
        this.hiddenDistrictId = districtId;
      }
      this.showDistrictField(settlementId, districts);
    },

    /**
     * Удаление модели района из коллекции при удалении
     * блока доставки
     */
    removeDistrict: function () {
      var jpModelDistrictId = this.jpModel && this.jpModel.get('district_id');
      if (jpModelDistrictId && this.jpDistricts) {
        this.jpDistricts.remove(this.jpDistricts.get(jpModelDistrictId));
      }
    },

    /**
     * Отображает поле выбора района указанного города.
     * @param {number} settlementId ID населенного пункта.
     * @param {Object} districts Коллекция районов города
     */
    showDistrictField: function (settlementId, districts) {
      if (!settlementId) {
        this._districtSuccess();
        return;
      }
      if (districts instanceof app.Districts) {
        this.districts = districts.clone();
        this._districtSuccess();
        return;
      }
      if (this.districts.fetchCounter < 1 || this.model.get('id') !== settlementId){
        this.districts.reset();
        this.isOpenPopup = false;
        this.districts.fetch({
          data: 'settlement_id='+ settlementId,
          success: this._districtSuccess.bind(this)
        });
      }
    },

    /**
     * Удачная смена района
     * @private
     */
    _districtSuccess: function () {
      if (!this.filledFields) {
        this.fillDistrictValue();
      }
      if (this.districts.models.length) {
        var models = [];
        _.compact(this.jpDistrictsIds).forEach(function (i) {
          models.push(this.districts.get(i));
          this.jpDistricts.add(models);
        }.bind(this));
        this.districtFields.removeClass('not_display');
        this.trigger('ready');
        this.render();
        if (this.isOpenPopup) {
          this.isOpenPopup = false;
          this.togglePopup();
        }
        return;
      }
      this.districtFields.addClass('not_display');
      this.trigger('ready');
      this.render();
    },

    /**
     * Скрывает поле выбора района для случая, когда у города нет районов.
     */
    hideDistrictField: function () {
      this.districtFields.addClass('not_display');
    },

    /**
     * Отображение/скрытие блока со списком районов при клике на input.
     */
    togglePopup: function () {
      if (this.districts.models.length) {
        this.districtSelect.find('.popup').toggleClass('not_display');
        this.arrowSelectToggle();
      } else {
        this.isOpenPopup = true;
      }
    },

    /**
     * Меняет состояние стрелки в инпуте.
     */
    arrowSelectToggle: function () {
      this.$('.district .arrow_down').toggleClass('arrow_up');
    },

    /**
     * Скрытие блока со списком районов.
     */
    hidePopup: function () {
      this.districtSelect.find('.popup').addClass('not_display');
      this.districtInput.blur();
    },

    /**
     * Меняет направление стрелки вниз
     */
    arrowSelectDown: function () {
      this.$('.district .arrow_down').removeClass('arrow_up');
    },

    /**
     * Выбор района.
     * @param {object} e
     */
    selectDistrict: function (e) {
      var prevId = this.selectedDistrictId || parseInt(this.districtInputId.val(), 10);
      this.selectedDistrict = $(e.target).text();
      this.selectedDistrictId = parseInt($(e.target).data('district-id'), 10);
      this.districtInput.val(this.selectedDistrict);
      this.districtInputId.val(this.selectedDistrictId);
      this.hidePopup();
      this.arrowSelectDown();
      this.districtInputId.trigger('change');
      if (this.jpDistricts) {
        this.jpDistricts.remove(this.jpDistricts.where({id: prevId}));
        this.jpDistricts.add(this.districts.get(this.selectedDistrictId));
      }
    },

    /**
     * Ренедринг списка районов.
     */
    render: function () {
      if (this.jpDistricts && this.jpDistricts.length > 0) {
        var models = this.districts.models.filter(function (i) {
          return !this.jpDistricts.models.some(function (j) {
            return i.get('id') === j.get('id');
          });
        }.bind(this));
        this.districtSelect.html(this.districtTemplate(models));
      } else {
        this.districtSelect.html(this.districtTemplate(this.districts.models));
      }
    },

    /**
     * Заполнение полей наименования и идентификатора района
     */
    fillDistrictValue: function () {
      var districtValue = 'Выберите район',
        districtIdValue = '';
      if (this.withHiddenDistrictField && this.districts.length) {
        var hiddenDistrict = this.hiddenDistrictId
          ? this.districts.get(this.hiddenDistrictId)
          : this.districts.at(_.random(0, this.districts.length - 1));
        if (hiddenDistrict && this.model.get('id') === hiddenDistrict.get('settlement_id')) {
          districtValue = hiddenDistrict.get('name');
          districtIdValue = hiddenDistrict.get('id');
        }
      }
      this.districtInput.val(districtValue);
      this.districtInputId.val(districtIdValue);
    }
  });

  _.extend(app.DistrictPopupView.prototype, app.ClosePopupMixin);

})();

}.call(window));